<template>
  <div class="autocomplete">
    <span class="search-icon-style material-icons-outlined">search</span>
    <input
      placeholder="Buscar vídeo"
      class="input-style"
      type="text"
      @input="onChange"
      v-model="search"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
    />
    <ul
      id="autocomplete-results"
      v-show="isOpen"
      class="autocomplete-results"
    >
      <li
        class="loading"
        v-if="isLoading"
      >
        Cargando resultados...
      </li>
      <li
        v-else
        v-for="(result, i) in results"
        :key="i"
        @click="setResult(result)"
        class="autocomplete-result"
        :class="{ 'is-active': i === arrowCounter }"
      >
        {{ result }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'SearchAutocomplete',
    props: {
      items: {
        type: Array,
        required: false,
        default: () => [],
      },
      isAsync: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        isOpen: false,
        results: [],
        search: '',
        isLoading: false,
        arrowCounter: -1,
      };
    },
    watch: {
      items: function (value, oldValue) {
        if (value.length !== oldValue.length) {
          this.results = value;
          this.isLoading = false;
        }
      },
    },
    created(){
    },
    mounted() {
      document.addEventListener('click', this.handleClickOutside)
    },
    destroyed() {
      document.removeEventListener('click', this.handleClickOutside)
    },
    methods: {
      setResult(result) {
        this.search = result;
        this.isOpen = false;
        this.$emit("input_value", this.search);
      },
      filterResults() {
        this.results = this.items.filter((item) => {
          if(this._acuteAccentChecker(this.search) == true){
            return item.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
          } else{
            return item.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(this.search.toLowerCase()) > -1;
          }
        });
      },

      _acuteAccentChecker(search){
        let accentChars = ['á', 'é', 'í', 'ó', 'ú'];
        return accentChars.some(char => search.includes(char));
      },

      onChange() {
        this.$emit('input', this.search);

        if (this.isAsync) {
          this.isLoading = true;
        } else {
          this.filterResults();
          this.isOpen = true;
        }
      },
      handleClickOutside(event) {
        if (!this.$el.contains(event.target)) {
          this.isOpen = false;
          this.arrowCounter = -1;
        }
      },
      onArrowDown() {
        if (this.arrowCounter < this.results.length) {
          this.arrowCounter = this.arrowCounter + 1;
        }
      },
      onArrowUp() {
        if (this.arrowCounter > 0) {
          this.arrowCounter = this.arrowCounter - 1;
        }
      },
      onEnter() {
        this.search = this.results[this.arrowCounter];
        this.isOpen = false;
        this.arrowCounter = -1;
      },
    },
  };
</script>

<style>

  .input-style{
    border: 1px solid #d6d7dc;
    height: 40px;
    width: 300px;
    font-size: 15px;
    padding-left: 45px;
    background-color: #f3f4f7;
    border-radius: 25px;
  }

  .input-style:focus{
    outline: none;
  }

  .autocomplete {
    position: relative;
  }

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #d6d7dc;
    border-radius: 5px;
    height: 120px;
    overflow: auto;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  .autocomplete-result.is-active,
  .autocomplete-result:hover {
    background-color: #0f0f1a;
    color: white;
  }

  .search-icon-style{
    position: absolute;
    top: 10px;
    left: 15px;
  }

  ::placeholder{
    color: #898d9c;
  }
</style>